import { useEffect } from "react";
import { Button, TextField } from "@mui/material";

const ContactForm = () => {
  useEffect(() => {
    scrollToHash();
  },[]);
  function scrollToHash() {
    const id = window.location.hash.substr(1);
    if(id) {
      const anchor = document.getElementById(id);
      if(anchor) {
        anchor.scrollIntoView();
      }
    }
  }
  return (
    <form name="contact" method="POST" data-netlify="true" action="/#/success" id="contact-us">
      <input type="hidden" name="form-name" value="contact" />
      <TextField
        type="text"
        label="Name"
        name="name"
        autoComplete="new-password"
        fullWidth={true}
        variant="outlined"
        className="mb-3"
        required={true}
        inputProps={{ maxLength: 45 }}
      />
      <TextField
        label="E-mail"
        name="email"
        autoComplete="new-password"
        fullWidth={true}
        variant="outlined"
        className="mb-3"
        required={true}
        type="email"
        inputProps={{ maxLength: 45 }}
      />
      <TextField
        label="Message"
        name="message"
        autoComplete="new-password"
        fullWidth={true}
        variant="outlined"
        className="mb-3"
        multiline
        rows={5}
        required={true}
        type="text"
        inputProps={{ maxLength: 1000 }}
      />
      <Button
        variant="contained"
        color="primary"
        type="submit"
      >
        Submit
      </Button>
    </form>
  )
};

export default ContactForm;
